// shopping types
export default {
  GET_SUBSCRIPTIONS: 'GET_SUBSCRIPTIONS',
  UPDATE_SUBSCRIPTION: 'UPDATE_SUBSCRIPTION',
};
